/**
 * Browser entry point.
 *
 * BrowserRouter (rather than HashRouter) means real URLs — /privacy, not
 * /#/privacy — which is what lets them be indexed, shared and used as the
 * privacy-policy URL an app store requires. It depends on the server returning
 * index.html for unknown paths, which apps/worker/src/app.ts does.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import './styles/base.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('No #root element in index.html — the app has nowhere to mount.');
}

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
